import l from "react-textarea-autosize";
import t, { css as n } from "styled-components";
import o from "../../utils/colors.js";
import { device as r } from "../../utils/device.js";
const m = t.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  width: 100%;

  @media ${r.isDesktop}, ${r.isTablet} {
    max-width: 350px;
  }
`, i = t.label`
  align-self: stretch;
  font-family: VIC;
  font-weight: 600;
  overflow-wrap: break-word;
  margin-bottom: 8px;
  color: ${o.blueGrey};
`, c = t(i)`
  font-weight: 400;
  margin-top: 8px;
  color: ${o.blueGrey75};
`, f = t(i)`
  color: ${o.red};
  margin-top: 8px;
  font-weight: 400;
`, x = t(l)`
  padding: 11.5px 16px !important;
  ${(e) => e.mode === "Input" && `overflow: hidden !important;
  `};
  align-self: stretch;
  height: 152px;
  border-radius: 2px;
  font-size: 1rem;
  font-family: VIC;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  outline: 0px !important;
  color: ${o.blueGrey};
  resize: ${(e) => e.mode !== "Input" ? "auto" : "none"};
  border: solid 1px
    ${(e) => e.$error == "true" ? o.red : e.disabled ? o.darkGrey75 : o.blueGrey};
  background-color: ${(e) => e.disabled ? o.darkGrey10 : o.white};
  padding: 0 16px;

  ${(e) => e.disabled ? " cursor: not-allowed;" : n`&:active,
&:focus {
  border: solid 1px ${o.orange};
}`};
`;
export {
  f as ErrorLabel,
  c as HintLabel,
  i as Label,
  x as TextArea,
  m as Wrapper
};
